/**
 * 抑制 ResizeObserver / Select 在路由或 Tab 切换时的噪声报错。
 * 须在 main.js 最顶部 import，避免 dev-server overlay 误报。
 */
const isBenignObserverError = (message) =>
  typeof message === 'string' &&
  (/ResizeObserver loop/i.test(message) ||
    /Failed to execute 'getComputedStyle'/i.test(message) ||
    /parameter 1 is not of type 'Element'/i.test(message))

if (!window.__resizeObserverErrorPatched) {
  window.__resizeObserverErrorPatched = true

  const swallowBenignError = (event) => {
    const msg = event?.message || event?.reason?.message || ''
    if (!isBenignObserverError(msg)) return
    event.stopImmediatePropagation()
    if (typeof event.preventDefault === 'function') event.preventDefault()
  }

  window.addEventListener('error', swallowBenignError, true)
  window.addEventListener('unhandledrejection', swallowBenignError, true)

  const NativeResizeObserver = window.ResizeObserver
  if (NativeResizeObserver) {
    window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          try {
            if (!Array.isArray(entries) || !entries.length) return
            const validEntries = entries.filter(
              (entry) => entry?.target instanceof Element && entry.target.isConnected
            )
            if (!validEntries.length) return
            callback(validEntries, observer)
          } catch (err) {
            if (!isBenignObserverError(err?.message)) {
              throw err
            }
          }
        })
      }
    }
  }
}
